import React from 'react';
import { motion } from 'framer-motion';

const EASE = [0.76, 0, 0.24, 1];
const LOGO = '/logo-white.png';

export const HeroCurtain = ({ onDone }) => (
  <motion.div
    className="fixed inset-0 z-[80] bg-black flex items-center justify-center pointer-events-none"
    initial={{ y: '0%' }}
    animate={{ y: '-100%' }}
    transition={{ duration: 1.1, ease: EASE, delay: 1.5 }}
    onAnimationComplete={onDone}
    data-testid="hero-curtain"
  >
    <motion.div
      initial={{ opacity: 0, scale: 0.85, clipPath: 'inset(0% 0% 100% 0%)' }}
      animate={{ opacity: [0, 1, 1, 1], scale: [0.85, 1, 1, 1.04], clipPath: ['inset(0% 0% 100% 0%)', 'inset(0% 0% 0% 0%)', 'inset(0% 0% 0% 0%)', 'inset(0% 0% 0% 0%)'] }}
      transition={{ duration: 2.3, times: [0, 0.35, 0.7, 1], ease: EASE }}
    >
      <img src={LOGO} alt="Obsidian Chauffeurs" className="h-44 md:h-64 w-auto" data-testid="hero-curtain-logo" />
    </motion.div>
  </motion.div>
);
